// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinkStyles } from "@awc/Overrides/Widgets/Common/CartLink";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

cartLinkStyles.routerLink = {
    icon: {
        iconProps: {
            size: 26,
            css: css`
                &,
                svg {
                    height: 19px;
                    margin: 0;
                    ${xScreen("lte", "sm")} {
                        height: 22px;
                        width: 30px;
                    }
                }
            `,
        },
    },
    color: "text.main",
    css: css`
        height: 40px;
        width: 44px;
        padding: 0;
        position: relative;
        &:hover,
        &:focus {
            ${IconWrapper}, svg {
                color: ${color("common.ui8")};
            }
        }
        ${xScreen("lte", "md")} {
            margin-right: 8px;
        }
    `,
};

cartLinkStyles.desktopCountText = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    weight: fontConfig.weight.bold,
    color: "common.ui1",
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        background: ${color("primary")};
        width: 26px;
        height: 26px;
        border-radius: 50%;
        position: absolute;
        right: 0;
        top: -9px;
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};
